export default "__VITE_ASSET__CLUObXjx__"